module.exports = "https://static.im-cdn.com/mjc/storefront/Coral/static/media/RightArrow.9cfe945b.svg";